import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3597d978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-viewer-mobile-header level is-mobile flex-grow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_TheVideoViewer = _resolveComponent("TheVideoViewer")!
  const _component_HelpImageViewerMobile = _resolveComponent("HelpImageViewerMobile")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_AddonView = _resolveComponent("AddonView")!
  const _component_ModalSheet = _resolveComponent("ModalSheet")!

  return (_openBlock(), _createBlock(_component_ModalSheet, {
    class: "video-viewer-mobile",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_ButtonIcon, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.modal = 'addonView')),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.state.modal = 'addonView'), ["prevent"]), ["space","enter"])),
          icon: "list-bullet",
          styled: "is-none",
          id: "video-viewer-mobile-header-addonview-button"
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TheVideoViewer, {
        item: _ctx.item,
        viewerType: _ctx.viewerType
      }, null, 8, ["item", "viewerType"]),
      _createElementVNode("div", null, [
        _createVNode(_TransitionGroup, { name: "modal" }, {
          default: _withCtx(() => [
            (_ctx.state.modal === 'help')
              ? (_openBlock(), _createBlock(_component_ModalWindow, {
                  key: 0,
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.modal = '')),
                  heading: _ctx.$t('header.help'),
                  id: "help-video-viewer-modal-window"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_HelpImageViewerMobile, { lang: _ctx.lang }, null, 8, ["lang"])
                  ]),
                  _: 1
                }, 8, ["heading"]))
              : _createCommentVNode("", true),
            (_ctx.state.modal === 'addonView')
              ? (_openBlock(), _createBlock(_component_ModalSheet, {
                  key: 1,
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.modal = '')),
                  class: "has-background-contents",
                  id: "addon-view-video-viewer-modal-window"
                }, {
                  header: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_AddonView, {
                      item: _ctx.item,
                      "tab-view-flag": _ctx.tabViewFlag,
                      "viewer-type": "TheVideoViewer"
                    }, null, 8, ["item", "tab-view-flag"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}